import React, { Component } from "react";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import { message } from "antd";
import GenderInfoComponent from "../basicdetails/GenderInfo";
import EcasGenderInfoComponent from "../ecasBasicDetails/GenderInfo";
import { RESEARCH_TYPE } from "../../utils/consts";

import LEStudyGenderInfoComponent from "../leStudy/demographicsComponents/als/GenderInfo";
import LEStudyGenderInfoComponentControls from "../leStudy/demographicsComponents/controls/GenderInfo";

import englishJson from "../../utils/language/leStudy/english.json";
import spanishJson from "../../utils/language/leStudy/spanish.json";

export default class GenderInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active_step: "1",
    };
  }
  selectUserType = (param) => {
    this.setState({
      active: param,
    });
  };
  continue = () => {
    if (!this.state.active) {
      message.warning("Please select account");
      return;
    }
  };
  onChange = (date, dateString) => {
    this.setState({
      date_of_birth: date,
    });
  };
  set_active_step = (step) => {
    this.setState({ active_step: step });
  };
  render() {
    const formData =
      RESEARCH_TYPE == "LE Study"
        ? this.props.language == "English"
          ? englishJson
          : spanishJson
        : englishJson;
    return (
      <div>
        <Header />
        <div className="main-content demographics-section-wrapper">
          <div className="container">
            <div className="row">
              <div className="col-lg-11 m-auto">
                <div className="demographic-single-section">
                  <a
                    href="/about-me"
                    style={{ width: 95 }}
                    className="back-arrow width-fit-content"
                  >
                    <box-icon
                      name="chevron-left"
                      color="#fff"
                      style={{ position: "relative", top: 1 }}
                    ></box-icon>
                    {formData.page.backButtonTextAboutMe}
                  </a>
                  {RESEARCH_TYPE == "Asymptomatic Study" && (
                    <GenderInfoComponent
                      set_active_step={this.set_active_step}
                      is_update={true}
                    />
                  )}
                  {RESEARCH_TYPE == "ECAS Study" && (
                    <EcasGenderInfoComponent
                      set_active_step={this.set_active_step}
                      is_update={true}
                    />
                  )}
                  {RESEARCH_TYPE == "LE Study" && (
                    <>
                      {localStorage.getItem("ap_relation_to_als") ==
                        "Living with ALS" && (
                        <LEStudyGenderInfoComponent
                          set_active_step={this.set_active_step}
                          is_update={true}
                          language={this.props.language}
                        />
                      )}
                      {localStorage.getItem("ap_relation_to_als") ==
                        "Healthy control" && (
                        <LEStudyGenderInfoComponentControls
                          set_active_step={this.set_active_step}
                          is_update={true}
                          language={this.props.language}
                        />
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
